import {Component, Input} from "@angular/core";
import {ProductCountDownData} from "../product-count-down.data";
import {EntityData} from "@fedeltapointofsale/data-client";
import {FormGroup} from "@angular/forms";
import {EntityFormBuilder} from "../../../framework/entity/edit/entity-form-builder/entity-form-builder";
import {ItemAvailability} from "../app-item-availability-search.model";

@Component({
    selector: "wbo-app-item-availability-edit-form",
    styleUrls: ["./app-item-availability-edit-form.component.scss"],
    templateUrl: "./app-item-availability-edit-form.component.html"
})
export class AppItemAvailabilityEditFormComponent {
    ItemAvailability = ItemAvailability;

    @Input() sellableId: number;
    @Input() outletGroupId: number;
    @Input() countdowns: { [sellableId: string]: ProductCountDownData } = {};

    formGroup: FormGroup;

    constructor(private entityFormBuilder: EntityFormBuilder) {
        this.formGroup = this.entityFormBuilder.customGroup({
            productCount: [""],
            resetAtStartOfDay: [""],
            restockLevel: [""]
        });
    }

    getOrCreateCountDown(): ProductCountDownData {
        let countdown: ProductCountDownData = this.countdowns[this.sellableId];
        if (!countdown) {
            countdown = EntityData.create(ProductCountDownData);
            countdown.locationId = this.outletGroupId;
            countdown.sellableId = this.sellableId;
            this.countdowns[this.sellableId] = countdown;
        }
        return countdown;
    }

    get productCount(): number {
        return this.countdowns[this.sellableId] ? this.countdowns[this.sellableId].productCount : undefined;
    }

    set productCount(productCount: number) {
        const countdown: ProductCountDownData = this.getOrCreateCountDown();
        if (countdown.productCount !== productCount) {
            countdown.isDirty = true;
            countdown.productCount = productCount;
            countdown.soldOutToday = productCount === 0;
        }
        this.formGroup.get("productCount").setValue(productCount);
    }

    get soldOutToday(): boolean {
        return this.countdowns[this.sellableId] ? this.countdowns[this.sellableId].soldOutToday : undefined;
    }

    set soldOutToday(soldOutToday: boolean) {
        const countdown: ProductCountDownData = this.getOrCreateCountDown();
        if (countdown.soldOutToday !== soldOutToday) {
            countdown.isDirty = true;
            countdown.soldOutToday = soldOutToday;
        }
    }

    get notSold(): boolean {
        return this.countdowns[this.sellableId] ? this.countdowns[this.sellableId].notSold : undefined;
    }

    set notSold(notSold: boolean) {
        const countdown: ProductCountDownData = this.getOrCreateCountDown();
        if (countdown.notSold !== notSold) {
            countdown.isDirty = true;
            countdown.notSold = notSold;
        }
    }

    get resetAtStartOfDay(): boolean {
        return this.countdowns[this.sellableId] ? this.countdowns[this.sellableId].resetAtStartOfDay : undefined;
    }

    set resetAtStartOfDay(resetAtStartOfDay: boolean) {
        const countdown: ProductCountDownData = this.getOrCreateCountDown();
        if (countdown.resetAtStartOfDay !== resetAtStartOfDay) {
            countdown.isDirty = true;
            countdown.resetAtStartOfDay = resetAtStartOfDay;
        }
        this.formGroup.get("resetAtStartOfDay").setValue(resetAtStartOfDay);
    }

    get restockLevel(): number {
        return this.countdowns[this.sellableId] ? this.countdowns[this.sellableId].restockLevel : undefined;
    }

    set restockLevel(restockLevel: number) {
        const countdown: ProductCountDownData = this.getOrCreateCountDown();
        if (countdown.restockLevel !== restockLevel) {
            countdown.isDirty = true;
            countdown.restockLevel = restockLevel;
        }
        this.formGroup.get("restockLevel").setValue(restockLevel);
    }

    decrementProductCount() {
        const productCount: number = this.countdowns[this.sellableId] ? (this.countdowns[this.sellableId].productCount || 0) : 0;
        if (productCount > 0) {
            this.productCount = productCount - 1;
        }
    }

    incrementProductCount() {
        const productCount: number = this.countdowns[this.sellableId] ? (this.countdowns[this.sellableId].productCount || 0) : 0;
        this.productCount = productCount + 1;
    }

    getProductCountLabel(): string {
        const productCount: number = this.productCount;
        return productCount === 0 ? "wbo.web-ordering-menu.edit.message.touchItems.outOfStock"
            : !productCount ? "wbo.web-ordering-menu.edit.message.touchItems.unlimited"
                : "";
    }

    showProductCountLabel(): boolean {
        const productCount: number = this.productCount;
        return productCount === 0 || productCount == undefined;
    }

    getAvailabilityValue(): number {
        return this.notSold ? ItemAvailability.NOT_SOLD
            : this.productCount !== 0 ? ItemAvailability.AVAILABLE
                : this.soldOutToday ? ItemAvailability.SOLD_OUT_TODAY
                    : ItemAvailability.SOLD_OUT;
    }

    updateAvailability(option: number): void {
        if (option === ItemAvailability.NOT_SOLD) {
            this.notSold = true;
        } else if (option === ItemAvailability.AVAILABLE) {
            this.productCount = undefined
            this.soldOutToday = false;
            this.notSold = false;
        } else {
            this.productCount = 0;
            this.soldOutToday = option === ItemAvailability.SOLD_OUT_TODAY;
            this.notSold = false;
        }
    }
}
